export interface IQuery { }

export class CapexMetricConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.CapexMetricConfigurationQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	MetricId: string

	constructor (workspaceId: number, strategyId: string, metricId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.MetricId = metricId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.CapexMetricConfigurationQueryV1, TCh.Domain.Quest'
	}

}

export class CostSubtotalMetricConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.CostSubtotalMetricConfigurationQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	MetricId: string

	constructor (workspaceId: number, strategyId: string, metricId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.MetricId = metricId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.CostSubtotalMetricConfigurationQueryV1, TCh.Domain.Quest'
	}

}

export class ExpenseMetricConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.ExpenseMetricConfigurationQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	MetricId: string

	constructor (workspaceId: number, strategyId: string, metricId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.MetricId = metricId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.ExpenseMetricConfigurationQueryV1, TCh.Domain.Quest'
	}

}

export class MarginCogsMetricConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.MarginCogsMetricConfigurationQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	MetricId: string

	constructor (workspaceId: number, strategyId: string, metricId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.MetricId = metricId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.MarginCogsMetricConfigurationQueryV1, TCh.Domain.Quest'
	}

}

export class MetricsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.MetricsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.MetricsPageQueryV1, TCh.Domain.Quest'
	}

}

export class OpexMetricConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.OpexMetricConfigurationQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	MetricId: string | null

	constructor (workspaceId: number, strategyId: string, metricId: string | null)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.MetricId = metricId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.OpexMetricConfigurationQueryV1, TCh.Domain.Quest'
	}

}

export class ResourceCostMetricConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.ResourceCostMetricConfigurationQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	MetricId: string

	constructor (workspaceId: number, strategyId: string, metricId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.MetricId = metricId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.ResourceCostMetricConfigurationQueryV1, TCh.Domain.Quest'
	}

}

export class ResourceMetricConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.ResourceMetricConfigurationQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	MetricId: string

	constructor (workspaceId: number, strategyId: string, metricId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.MetricId = metricId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.ResourceMetricConfigurationQueryV1, TCh.Domain.Quest'
	}

}

export class RevenueMetricConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.RevenueMetricConfigurationQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	MetricId: string

	constructor (workspaceId: number, strategyId: string, metricId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.MetricId = metricId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.RevenueMetricConfigurationQueryV1, TCh.Domain.Quest'
	}

}

export class TotalCostMetricConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Metrics.Queries.TotalCostMetricConfigurationQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	MetricId: string

	constructor (workspaceId: number, strategyId: string, metricId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.MetricId = metricId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Metrics.Queries.TotalCostMetricConfigurationQueryV1, TCh.Domain.Quest'
	}

}

